import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
/**
 * @deprecated use @faire/web--source/common/globals/getWindow
 */ export var getWindow = function() {
    return getWindowOrThrow();
};
